import {
  Divider,
  GKButton,
  GKTextField,
  Grid2,
  PhoneInput,
  SimpleLoader,
  Typography,
} from "components";
import { useFetchQuery, useMutation } from "hooks/useQueries";
import { ComplianceGrievanceInterface } from "interfaces/WebsiteInterface";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import axiosInstance from "utils/axiosInstance";

const ComplianceGrievance = () => {
  const [hasError, setHasError] = useState(false);

  const { data, isFetching } = useFetchQuery({
    key: ["GET_COMPLIANCE_GRIEVANCE"],
    route: "/compliance-griv/",
  });

  const form = useForm<ComplianceGrievanceInterface>({
    defaultValues: {
      sebiRegisteredSupervisoryBody: "",
      supervisoryBodyMembershipId: "",
      complianceOfficerName: "",
      grievanceOfficerName: "",
      complianceRedressalEmail: "",
      grievanceRedressalEmail: "",
      compliancePhoneNumber: "",
      grievancePhoneNumber: "",
      complianceCountryCode: "+91",
      grievanceCountryCode: "+91",
    },
    values: data?.data?.data,
  });

  const { mutate, isLoading } = useMutation({
    mutationKey: ["UPDATE_COMPLIANCE_GRIEVANCE"],
    mutationFn: (data) =>
      axiosInstance.patch(`/compliance-griv/update-grievance/`, data),
  });

  if (isFetching) return <SimpleLoader />;

  return (
    <form onSubmit={form.handleSubmit((values) => mutate(values))}>
      <Grid2 container spacing={2}>
        <Grid2 size={3}>
          <Typography
            fontSize={16}
            fontWeight={500}
            color={"var(--neutral-500)"}
          >
            SEBI Info
          </Typography>
        </Grid2>

        <Grid2 container size={9} spacing={2}>
          <Grid2 size={6}>
            <Controller
              name="sebiRegisteredSupervisoryBody"
              control={form.control}
              render={({ field }) => (
                <GKTextField
                  {...field}
                  inputLabel="SEBI Registered Supervisory Body"
                />
              )}
            />
          </Grid2>
          <Grid2 size={6}>
            <Controller
              name="supervisoryBodyMembershipId"
              control={form.control}
              render={({ field }) => (
                <GKTextField
                  {...field}
                  inputLabel="Supervisory Body Membership Id"
                />
              )}
            />
          </Grid2>
        </Grid2>

        <Grid2 size={12} my={1}>
          <Divider />
        </Grid2>

        <Grid2 size={3}>
          <Typography
            fontSize={16}
            fontWeight={500}
            color={"var(--neutral-500)"}
          >
            Compliance Info
          </Typography>
        </Grid2>

        <Grid2 container size={9} spacing={2}>
          <Grid2 size={4}>
            <Controller
              name="complianceOfficerName"
              control={form.control}
              render={({ field }) => (
                <GKTextField {...field} inputLabel="Compliance Officer Name" />
              )}
            />
          </Grid2>
          <Grid2 size={4}>
            <Controller
              name="complianceRedressalEmail"
              control={form.control}
              render={({ field }) => (
                <GKTextField
                  {...field}
                  inputLabel="Compliance Redressal Email"
                />
              )}
            />
          </Grid2>
          <Grid2 size={4}>
            <Controller
              name="compliancePhoneNumber"
              control={form.control}
              rules={{
                required: {
                  value: true,
                  message: "Please enter phone number",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <PhoneInput
                  {...field}
                  onSelectChange={(event: any) => {
                    form.setValue("complianceCountryCode", event);
                  }}
                  onTextChange={(event: any) => {
                    field.onChange(event);
                  }}
                  inputLabel="Compliance Phone Number"
                  onTextValue={field.value}
                  onSelectValue={form.getValues("complianceCountryCode")}
                  error={!!error || hasError}
                  helperText={error?.message}
                  hasError={hasError}
                  setHasError={setHasError}
                />
              )}
            />
          </Grid2>
        </Grid2>

        <Grid2 size={12} my={1}>
          <Divider />
        </Grid2>

        <Grid2 size={3}>
          <Typography
            fontSize={16}
            fontWeight={500}
            color={"var(--neutral-500)"}
          >
            Grievance Info
          </Typography>
        </Grid2>

        <Grid2 container size={9} spacing={2}>
          <Grid2 size={4}>
            <Controller
              name="grievanceOfficerName"
              control={form.control}
              render={({ field }) => (
                <GKTextField {...field} inputLabel="Grievance Officer Name" />
              )}
            />
          </Grid2>
          <Grid2 size={4}>
            <Controller
              name="grievanceRedressalEmail"
              control={form.control}
              render={({ field }) => (
                <GKTextField
                  {...field}
                  inputLabel="Grievance Redressal Email"
                />
              )}
            />
          </Grid2>
          <Grid2 size={4}>
            <Controller
              name="grievancePhoneNumber"
              control={form.control}
              rules={{
                required: {
                  value: true,
                  message: "Please enter phone number",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <PhoneInput
                  {...field}
                  inputLabel="Grievance Phone Number"
                  onSelectChange={(event: any) => {
                    form.setValue("grievanceCountryCode", event);
                  }}
                  onTextChange={(event: any) => {
                    field.onChange(event);
                  }}
                  onTextValue={field.value}
                  onSelectValue={form.getValues("grievanceCountryCode")}
                  error={!!error || hasError}
                  helperText={error?.message}
                  hasError={hasError}
                  setHasError={setHasError}
                />
              )}
            />
          </Grid2>
        </Grid2>

        <Grid2 size={12} mt={2} display={"flex"} justifyContent={"flex-end"}>
          <GKButton type="submit" variant="contained" loading={isLoading}>
            Save
          </GKButton>
        </Grid2>
      </Grid2>
    </form>
  );
};

export default ComplianceGrievance;
